import React, { useState, useEffect } from "react";
import { io } from "socket.io-client";
import { getActiveDisplaySettings } from "../Libs/api";
import Home from "./Home";
import Display from "./Display";
import Ads from "./Ads";

const Main = () => {
  const [displaySettings, setDisplaySettings] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [socket, setSocket] = useState(null);

  // WebSocket connection
  useEffect(() => {
    const newSocket = io(
      "https://api-third-shot-score-684526581556.asia-south1.run.app",
      //   "https://api-third-shot-score-684526581556.asia-south1.run.app",
      {
        transports: ["websocket", "polling"],
        timeout: 20000,
        reconnection: true,
        reconnectionAttempts: 5,
        reconnectionDelay: 1000,
        reconnectionDelayMax: 5000,
        maxReconnectionAttempts: 10,
        forceNew: true,
      }
    );

    // Connection event handlers
    newSocket.on("connect", () => {
      console.log("✅ Main WebSocket connected successfully");
      // Join display settings room
      newSocket.emit("joinDisplaySettings");
      // Fetch initial display settings
      fetchDisplaySettings();
    });

    newSocket.on("disconnect", (reason) => {
      console.log("❌ Main WebSocket disconnected:", reason);
    });

    newSocket.on("connect_error", (error) => {
      console.error("❌ Main WebSocket connection error:", error);
    });

    newSocket.on("reconnect", (attemptNumber) => {
      console.log(
        "🔄 Main WebSocket reconnected after",
        attemptNumber,
        "attempts"
      );
      // Re-join display settings room after reconnection
      newSocket.emit("joinDisplaySettings");
    });

    setSocket(newSocket);

    return () => {
      newSocket.close();
    };
  }, []);

  // Handle WebSocket messages for display settings updates
  useEffect(() => {
    if (!socket) return;

    socket.on("displaySettingsUpdate", (data) => {
      console.log("📊 Received display settings update:", data);
      setDisplaySettings(data.settings);
      setError(null);
    });

    return () => {
      socket.off("displaySettingsUpdate");
    };
  }, [socket]);

  const fetchDisplaySettings = async () => {
    try {
      const response = await getActiveDisplaySettings();

      if (response.success) {
        setDisplaySettings(response.data);
        setError(null);
      } else {
        setError("Failed to fetch display settings");
        console.error("Display settings error:", response.message);
      }
    } catch (error) {
      setError("Error fetching display settings");
      console.error("Display settings fetch error:", error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          fontSize: "24px",
          color: "#666",
          background:
            "linear-gradient(99.32deg, rgb(1, 30, 72) -0.41%, rgb(17, 64, 132) 93.61%)",
        }}
      >
        Loading display settings...
      </div>
    );
  }

  if (error) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          fontSize: "24px",
          color: "#ff6b6b",
          background:
            "linear-gradient(99.32deg, rgb(1, 30, 72) -0.41%, rgb(17, 64, 132) 93.61%)",
        }}
      >
        Error: {error}
      </div>
    );
  }

  // Determine which component to render based on display settings
  const renderComponent = () => {
    if (!displaySettings) {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
            fontSize: "24px",
            color: "#666",
            background:
              "linear-gradient(99.32deg, rgb(1, 30, 72) -0.41%, rgb(17, 64, 132) 93.61%)",
          }}
        >
          No display settings configured
        </div>
      );
    }

    // Priority order: ScoreDisplay > Ads > Leaderboard
    if (displaySettings.showScoreDisplay) {
      return <Display />;
    } else if (displaySettings.showAds) {
      return <Ads />;
    } else if (displaySettings.showLeaderboard) {
      return <Home displaySettings={displaySettings} />;
    } else {
      // Default fallback - show a message when no display option is active
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
            fontSize: "24px",
            color: "#666",
            background:
              "linear-gradient(99.32deg, rgb(1, 30, 72) -0.41%, rgb(17, 64, 132) 93.61%)",
          }}
        >
          No active display option selected
        </div>
      );
    }
  };

  return renderComponent();
};

export default Main;
